import React, { FC } from 'react';

import { FullscreenButton } from '../../../fullscreen';
import type { SharingZoomController } from '../../SharingZoomController';
import { ZoomControls } from '../zoom-controls';
import styles from './styles.css';

interface Props {
    controller: SharingZoomController;
    videoElementRef?: HTMLVideoElement | null;
    showFullscreenButton: boolean;
}

export const SharingControlsPanel: FC<Props> = ({ controller, videoElementRef, showFullscreenButton }) => {
    return (
        <div className={styles.root}>
            {showFullscreenButton && (
                <FullscreenButton videoElementRef={videoElementRef} className={styles.fullscreenButtonOverride} />
            )}
            <ZoomControls controller={controller} />
        </div>
    );
};
